//import scrollto from './scrollto.js';

export default function () {


    let tabs = document.getElementsByClassName('Tabs')

    if (!tabs.length) {
        return
    } else {
        let tabsNavItem = $('.ListingBlock-nav-item')
        let tabsSections = $('.Tabs-sections')
        let currTabHref = $('.ListingBlock-nav-item.is-active').attr('href')
        let stateObj = { tab: currTabHref }
        let tabsContainer = $('.Tabs')

        window.onpopstate = function (event) {
            if (event.state !== null) {
                let $hashElem = $('[href="' + event.state.tab + '"]')
                $hashElem.parent().siblings().removeClass('is-active');
                $hashElem.parent().addClass('is-active')
                $hashElem.parents('.Tabs').find('.Tabs-sections >*').removeClass('is-active');
                tabsSections.find('[id=' + event.state.tab.substr(1) + ']').addClass('is-active')
                getNextText();
            }
        };

        //history.replaceState(stateObj, currTabHref, currTabHref);

        tabsNavItem.on('click', function (e) {
            e.preventDefault()
            let $this = $(this).find('>*')
            let $tabHref = $this.attr('href')
            let $container = $this.parents('.Tabs')

            stateObj = { tab: $tabHref }
            history.pushState(stateObj, $tabHref, $tabHref)

            $container.find('.ListingBlock-nav-item').removeClass('is-active')

            $this.parent().addClass('is-active')

            //loop through all tabsSections child nodes and remove the class name of 'is-active'
            $container.find('.Tabs-sections >*').removeClass('is-active');
            $container.find('.Tabs-sections [id=' + $tabHref.substr(1) + ']').addClass('is-active')
            getNextText($container);
        })

        //on init load, check the url for a #, if it exists, try to apply active classes
        if (window.location.hash) {
            let urlHash = window.location.hash;
            $('[href="' + urlHash+ '"]').trigger('click')
            setTimeout(function () {
                if ($('[href="' + urlHash + '"]').parents('.ListingBlock-nav-item').length > 0) {
                    let urlHashTop = $('[href="' + urlHash + '"]').parents('.Tabs').offset().top
                    let pageNav = document.getElementsByClassName('PageNav')[0];

                    if (pageNav.classList.contains('PageNav-isHidden')) {
                        window.scrollTo(0, urlHashTop);
                    } else {
                        window.scrollTo(0, urlHashTop - pageNav.offsetHeight);
                    }
                }
            }, 100);

        }

        if (!!document.getElementsByClassName('TabNextButton').length && document.querySelectorAll('.ListingBlock-nav-item').length === 1) {
            document.getElementsByClassName('TabNextButton')[0].classList.add('u-hidden')
        }

        function getNextText($container) {
            if (!$container.find('.TabNextButton').length) return

            let initText = ($container.find('.TabNextButton').data('init-text') !== null ? $container.find('.TabNextButton').data('init-text') : '')
            let $currTab = $container.find('.ListingBlock-nav-item.is-active')
            let $hasNextTab = $currTab.next().length === 1
            let $nextText

            if ($hasNextTab) {
                $nextText = $container.find('.ListingBlock-nav-item.is-active').next().text()
                $container.find('.TabNextButton').removeClass('u-hidden')
                $container.find('.TabNextButton').text(initText + $nextText)
            } else {
                $container.find('.TabNextButton').addClass('u-hidden')
            }
        }

        if (tabsContainer.length) {
            for (let tabIndex = 0; tabIndex < tabsContainer.length; tabIndex++) {
                getNextText(tabsContainer.eq(tabIndex))
            }
        }

        $('.TabNextButton').on('click', function (e) {
            e.preventDefault();
            let $currTab = $(this).parents('.Tabs').find('.ListingBlock-nav-item.is-active')
            let $hasNextTab = $currTab.next().length === 1

            if ($hasNextTab) {
                $currTab.next().find('a').trigger('click')
            } else {
                $currTab.parent().find('>*').eq(0).find('a').trigger('click')
            }

            let myHref = $(this).parents('.Tabs');
            let myHrefHeight = myHref.offset().top - $('.PageNav').outerHeight()

            $('html:not(:animated), body:not(:animated)').animate({
                scrollTop: myHrefHeight
                }, 500);


            //scrollto.doScrolling(myHref, 500)
        })

        $('.TabGotoButton').on('click', function (e) {
            e.preventDefault()

            // get the href of the currently clicked button
            const $href = $(this).attr('href')

            // find the corresponding tabsNavItem that have an anchor tag with the same href and trigger a click event on it
            const tabLink = $(`.Tabs-nav-item[href="${$href}"]`)
            // get the offset top of the tablink and add body padding
            const offsetTop = tabLink.offset().top - $('.PageNav').outerHeight() - 50
            // scroll to the tabLink
            $('html:not(:animated), body:not(:animated)').animate({
                scrollTop: offsetTop
            }, 500);
            tabLink.trigger('click')
        })

    }
}